import { render, staticRenderFns } from "./PopupIframe.vue?vue&type=template&id=071a8680&"
import script from "./PopupIframe.vue?vue&type=script&lang=ts&"
export * from "./PopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports